import { Images } from 'assets/images';
import { StartYourTrip } from 'components';
import { HowItsWorkPageInformation } from '../data';
import {
  DesctopSteps,
  LeftStepsImg,
  MobileSteps,
  PlanningSteps,
  StepCount,
  StepImage,
  StepsContainer,
  StepsSectionContainer,
  StepsSectionTitle,
  StepsSubTitle,
  StepsTitle,
  StepsTitleWrapper,
  StepsYourTrips,
  StepWrapper,
} from '../styled';

export const StepsSection = () => (
  <StepsSectionContainer>
    <StepsSectionTitle>
        This is How ITAH’s Planning Process Works
    </StepsSectionTitle>
    <StepWrapper>
      <StepsTitleWrapper>
        <StepImage src={Images.step1} alt="Faq image" />
        <StepCount>Step 1</StepCount>
      </StepsTitleWrapper>
      <StepsContainer>
        <StepsTitle>{HowItsWorkPageInformation.step1.title}</StepsTitle>
        <StepsSubTitle>
          {HowItsWorkPageInformation.step1.description}
        </StepsSubTitle>
      </StepsContainer>
    </StepWrapper>

    <StepWrapper>
      <MobileSteps>
        <StepImage src={Images.step2} alt="Faq image" />
        <StepCount>Step 2</StepCount>
      </MobileSteps>
      <StepsContainer>
        <StepsTitle>{HowItsWorkPageInformation.step2.title}</StepsTitle>
        <StepsSubTitle>
          {HowItsWorkPageInformation.step2.description}
        </StepsSubTitle>
      </StepsContainer>
      <DesctopSteps>
        <PlanningSteps src={Images.PlanningSteps} />
        <LeftStepsImg src={Images.step2} alt="Faq image" />
      </DesctopSteps>
    </StepWrapper>

    <StepWrapper>
      <StepsTitleWrapper>
        <StepImage src={Images.step1} alt="Faq image" />
      </StepsTitleWrapper>
      <StepsContainer>
        <StepsTitle>{HowItsWorkPageInformation.step3.title}</StepsTitle>
        <StepsSubTitle>
          {HowItsWorkPageInformation.step3.description}
        </StepsSubTitle>
      </StepsContainer>
    </StepWrapper>

    <StepsYourTrips>
      <StartYourTrip />
    </StepsYourTrips>
  </StepsSectionContainer>
);
